import { render } from "./allcompanies.vue?vue&type=template&id=3116d910&scoped=true"
import script from "./allcompanies.vue?vue&type=script&lang=js"
export * from "./allcompanies.vue?vue&type=script&lang=js"

import "./allcompanies.vue?vue&type=style&index=0&id=3116d910&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3116d910"]])

export default __exports__